import React, { useState } from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";
import { yup } from "utils";

import Input from "../ControlledInput";
import { ErrorMessage } from "./components";

export const passwordValidation = yup
  .string()
  .min(8)
  .matches(/[0-9]/, { name: "number" })
  .matches(/[a-z]/, { name: "lowercase" })
  .matches(/[A-Z]/, { name: "uppercase" })
  .matches(/[!@#$%^&*]/, { name: "special" });

export function ControlledPassword({ name, showDefaultError, ...props }) {
  const [showPassword, setShowPassword] = useState(false);

  const {
    fieldState: { error },
  } = useController({ name: name, defaultValue: "" });

  return (
    <div>
      <Input
        {...props}
        hideError={showDefaultError}
        name={name}
        showDescriptionBelow
        description={
          !error?.message && showDefaultError
            ? "Use a minimum of 8 characters, including uppercase letter, lowercase letters, number and special character."
            : ""
        }
        type={showPassword ? "text" : "password"}
        error={!!error?.message}
        style={{ width: "100%" }}
        icon={
          <Icon
            name={showPassword ? "eye slash" : "eye"}
            link
            onClick={() => {
              return setShowPassword((prev) => {
                return !prev;
              });
            }}
          />
        }
      />
      {error && showDefaultError && <ErrorMessage errors={error?.types} />}
    </div>
  );
}

ControlledPassword.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  showDefaultError: PropTypes.bool,
};

ControlledPassword.defaultProps = {
  name: "password",
  placeholder: "Create a password",
  label: "Password",
  showDefaultError: true,
};

export default ControlledPassword;
